import { useForm, Controller } from 'react-hook-form';
import { FormProvider, TextField, Table, Checkbox, SelectTag } from '../../../../../../components';
import { Button, Container, Paper, Stack, Typography, Select, MenuItem, Dialog, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../../utils';
import { GENDER_DROPDOWN, TITLES } from '../../../../../../constants';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../../components';


const TABLE_COLUMNS = [
  {
    header: 'Title',
    accessor: 'title'
  },
  {
    header: 'Relation Name ',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black',
          }}
        >
          {`${row.name}`}
        </span>
      );
    },
  },

  {
    header: 'Gender',
    accessor: 'gender'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialRelationMasterDataObj = {
  data: [],
  loading: false
};

export const RelationMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [relationMasterDataObj, setRelationMasterDataObj] = useState(initialRelationMasterDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();



  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        title: Yup.string().required('Title is required'),
        name: Yup.string().required('Relation Name  is required'),
        gender: Yup.string().required('Gender is required')
      })
    ),
    defaultValues: { title: '', name: '', gender: '', default: false },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('title', selectedRecord.title);
      setValue('name', selectedRecord.name);
      setValue('gender', selectedRecord.gender);
      setValue('default', selectedRecord.status === 'default');
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/relation-master-update' : '/relation-master-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        title: formValues.title,
        name: formValues.name,
        gender: formValues.gender,
        status: formValues.default ? 'default' : 'active'
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Relation master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Relation master`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/relation-master-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Relation master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Relation master', { varaint: 'error' });
    }
    setLoading(false);
  };


  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/relation-master-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Relation master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Relation master', { varaint: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setRelationMasterDataObj({ loading: true });
    const response = await request('/relation-master-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(item =>
        item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setRelationMasterDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setRelationMasterDataObj({ loading: false });
    }
  };


  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',

          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Relation Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn id={"Exit"} variant="contained" onClick={() => {
                  setCurrentAction('');
                }} >Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={1}>
            <Box sx={{ border: '1px solid gray', padding: 2, borderRadius: '8px',width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.12, fontSize: '1.4rem', fontWeight: 700 }}>Title</Typography>
                <SelectTag
                  disabled={!['new', 'edit'].includes(currentAction)}
                  formControlSX={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  name="title"
                  menus={TITLES}
                />
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center" sx={{ marginTop: 0.5 }} >
                <Typography sx={{ flex: 0.12, fontSize: '1.4rem', fontWeight: 700 }}>Relation Title</Typography>
                <TextField
                  disabled={!['new', 'edit'].includes(currentAction)}
                  sx={{ flex: 1, border: currentAction ? "0.5px solid red" : "" }}
                  name="name"
                  placeholder="Relation Title "
                />
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center"  sx={{ marginTop: 0.5 }}>
                <Typography sx={{ flex: 0.13, fontSize: '1.4rem', fontWeight: 700 }}>Gender</Typography>
                <SelectTag
                  disabled={!['new', 'edit'].includes(currentAction)}
                  formControlSX={{ flex: 0.85, border: currentAction ? "0.5px solid red" : "" }}
                  name="gender"
                  menus={GENDER_DROPDOWN}
                />
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Default</Typography>
                  <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="default" fontSize={18} />
                </Stack>
              </Stack>
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 1.5 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Relation Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 1 }}
          columns={TABLE_COLUMNS}
          data={relationMasterDataObj.data || []}
          loading={relationMasterDataObj.loading}
          onRowClick={(row) => {
            setOpenQueryDialog(false);
            setSelectedRecord(row);
          }}
        />
      </Dialog>
    </>
  );
};
